import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './global';
import { theme } from './theme';
import { useState, useContext } from 'react';
import { App, Viewer, Broadside, Manual, Mint, TOS, PP, viewerLoader, AuthRedirect } from './routes';
import { AppContextProvider, AppContext } from './providers/AppContext';
import { AuthContext, AuthProvider } from './providers/AuthProvider';
import { Account, Home } from './pages';

import { createWeb3Modal } from '@web3modal/wagmi/react'
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config'
import { WagmiProvider } from 'wagmi'
import { mainnet, base, baseSepolia } from 'wagmi/chains';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

const IS_PRODUCTION = (process.env.REACT_APP_IS_PRODUCTION || 'false').toLowerCase() === 'true'

const chains = [mainnet];//IS_PRODUCTION ? [base] : [baseSepolia];
const projectId = 'b7fa64bece4cf45bfad47f013129c43c';
const metadata = {
  name: 'BaseJump',
  description: 'BaseJump',
  url: window.location.protocol + '//' + window.location.host,
  icons: ['https://images.squarespace-cdn.com/content/v1/65bb9799d452301e910b14dd/907a6c3a-828e-4e7c-ae1b-088e3bff3792/bjlogo.png?format=500w']
}

const config = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
  coinbasePreference: 'smartWalletOnly'
})

createWeb3Modal({
  wagmiConfig: config,
  projectId,
  featuredWalletIds: ['fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa']
})

const queryClient = new QueryClient()

const AccountWrapper = () => {
  const { accountAddress } = useContext(AppContext);
  return <Account accountAddress={accountAddress} />;
};

export default function AppWrapper() {
  const router = createBrowserRouter([
    { path: "/", element: (<App />), children: [
      { path: "broadside", element: (<Broadside />)},
      { path: "app", element: (<AccountWrapper />)},
      { path: "home", element: (<Home />)},
      { path: "mint", element: (<Mint />)},
    ] },
    { path: "manual", element: (<Manual />)},
    { path: "auth", element: (<AuthRedirect />)},
    { path: "terms", element: (<TOS />)},
    { path: "privacy", element: (<PP />)},
    { path: "viewer/:glbUrl", element: (<Viewer />), loader: viewerLoader },
  ]);


  return (
    <ThemeProvider theme={theme}>
      <>
	<WagmiProvider config={config}>
	  <QueryClientProvider client={queryClient}>
            <AppContextProvider>
	      <AuthProvider>
                <GlobalStyles />
                <RouterProvider router={router} />
	      </AuthProvider>
            </AppContextProvider>
	  </QueryClientProvider>
        </WagmiProvider>
      </>
    </ThemeProvider>
  );
}
